namespace Portico.Models.Enterprise {
	import IResponseModel = Portico.Models.Interfaces.IResponseModel;
	import IEnterpriseResponseModel = Portico.Models.Interfaces.IEnterpriseResponseModel;
    import ILegacyResponseModel = Portico.Models.Interfaces.ILegacyResponseModel;
    import ILegacyExternalResponseModel = Portico.Models.Interfaces.ILegacyExternalResponseModel;

    function isLegacyExternalResponse<TModel>(json: any): json is ILegacyExternalResponseModel<TModel> {
        return json && json.data && !!json.data.results;
    }

    export class ResponseModel<TModel> {
		private response: IResponseModel<TModel>;
		private enterpriseResponse: IEnterpriseResponseModel<TModel>;
        private legacyResponse: ILegacyResponseModel<TModel>;
        private legacyExternalResponse: ILegacyExternalResponseModel<TModel>;
        private type: ResponseModelType;

        constructor(json: any) {
            if (isLegacyExternalResponse<TModel>(json)) {
                this.legacyExternalResponse = json;
                this.type = ResponseModelType.ExternalLegacy;
                return;
            }

			this.response = json as IResponseModel<TModel>;

			if (this.response.success !== undefined) {
				this.type = ResponseModelType.Standard;
				return;
			}

			this.enterpriseResponse = json as IEnterpriseResponseModel<TModel>;

			if (this.enterpriseResponse.Success !== undefined) {
				this.type = ResponseModelType.Enterprise;
				return;
			}

			this.legacyResponse = json as ILegacyResponseModel<TModel>;

            if (this.legacyResponse.success !== undefined) {
                this.type = ResponseModelType.Legacy;
                return;
            }

            throw new Error('Unexpected data for ResponseModel.');
        }

        get success(): boolean {
            switch (this.type) {
				case ResponseModelType.Standard:
					return this.response.success;
				case ResponseModelType.Enterprise:
					return this.enterpriseResponse.Success;
                case ResponseModelType.Legacy:
                    return this.legacyResponse.success;
                case ResponseModelType.ExternalLegacy:
                    return this.legacyExternalResponse.success;
                default:
                    return false;
            }
        }

        get messages(): string[] {
            switch (this.type) {
                case ResponseModelType.Standard:
                    return this.response.messages;
				case ResponseModelType.Enterprise:
					return this.enterpriseResponse.Messages;
                case ResponseModelType.Legacy:
                    return this.legacyResponse.messages;
                case ResponseModelType.ExternalLegacy:
                    return this.legacyExternalResponse.messages;
                default:
                    return [];
            }
        }

        get data(): TModel {
            switch (this.type) {
                case ResponseModelType.Standard:
                    return this.response.data;
				case ResponseModelType.Enterprise:
					return this.enterpriseResponse.Data;
                case ResponseModelType.Legacy:
                    return this.legacyResponse.data;
                case ResponseModelType.ExternalLegacy:
                    return this.legacyExternalResponse.data.results;
                default:
                    return undefined;
            }
        }
    }
}